import React, { useState, useEffect, useRef, useMemo } from "react";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import DeleteIcon from "../../../Assets/Images/CommanImages/table_cross_icon.png";
import ReplaceIcon from "../../../Assets/Images/CommanImages/tabler_replace-filled.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
 
// ─── Date Dropdown ────────────────────────────────────────────────────────────
// const generateDateOptionsFromRange = (startDate, endDate) => {
//   const options = [];
//   if (!startDate || !endDate) return options;
 
//   const start = new Date(startDate);
//   const end = new Date(endDate);
 
//   for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
//     const label = d.toLocaleDateString("en-US", {
//       month: "short",
//       day: "2-digit",
//       year: "numeric",
//     });
//     const value = d.toISOString().split("T")[0];
//     options.push({ label, value });
//   }
 
//   return options;
// };

  const generateDateOptionsFromRange = (startDate, endDate, minDate) => {
    const options = [];
    if (!startDate || !endDate) return options;

    const start = new Date(startDate);
    const end = new Date(endDate);
    const min = minDate ? new Date(minDate) : null;

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      // Skip dates before minDate
      if (min && d < min) continue;

      const label = d.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      });
      const value = d.toISOString().split("T")[0];
      options.push({ label, value });
    }

    return options;
  };

const DateDropdown = ({ value, onChange, dateOptions }) => {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      style={{
        padding: "4px 6px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        cursor: "pointer",
        fontSize: "13px",
        color: "#2F2E40",
        background: "#fff",
        minWidth: "120px",
      }}
    >
      <option value="">Select date</option>
      {dateOptions.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};
 
// ─── Inner Table Component ────────────────────────────────────────────────────
const SelectedTipsTableComponent = ({
  headers,
  data,
  handleRemoveRow,
  handleReplaceRow,
  scheduledDates,
  setScheduledDates,
  dateOptions,
}) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const columnDropdownRef = useRef(null);
 
  useEffect(() => {
    if (headers.length > 0 && visibleColumns.length === 0) {
      setVisibleColumns(headers.slice(0, 5));
    }
  }, [headers]);
 
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  const handleColumnSelection = (column) => {
    if (column === headers[0]) return;
    setVisibleColumns((prev) =>
      prev.includes(column)
        ? prev.filter((c) => c !== column)
        : [...prev, column]
    );
  };
 
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
 
  const handleSort = (column) => {
    setSortConfig((prev) => ({
      key: column,
      direction:
        prev.key === column && prev.direction === "asc" ? "desc" : "asc",
    }));
  };
 
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };
 
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
 
  const filteredData = useMemo(
    () =>
      data.filter((row) =>
        searchQuery === ""
          ? true
          : row.some(
              (cell) =>
                cell &&
                String(cell).toLowerCase().includes(searchQuery.toLowerCase())
            )
      ),
    [data, searchQuery]
  );
 
  const sortedData = useMemo(() => {
    if (sortConfig.key === null) return filteredData;
    const colIndex = headers.indexOf(sortConfig.key);
    return [...filteredData].sort((a, b) => {
      if (a[colIndex] < b[colIndex])
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[colIndex] > b[colIndex])
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortConfig, headers]);
 
  const totalPages = Math.ceil(sortedData.length / pageSize);
 
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return sortedData.slice(start, start + pageSize);
  }, [sortedData, currentPage, pageSize]);
 
  const renderPagination = () => {
    const pages = [];
    const btn = (i) => (
      <button
        key={i}
        onClick={() => handlePageChange(i)}
        style={{ borderRadius: "5px" }}
        className={i === currentPage ? "active" : ""}
      >
        {i}
      </button>
    );
    const dots = (k) => (
      <span key={k} style={{ borderRadius: "5px" }}>
        ...
      </span>
    );
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(btn(i));
    } else if (currentPage <= 3) {
      [1, 2, 3].forEach((i) => pages.push(btn(i)));
      pages.push(dots("d1"));
      pages.push(btn(totalPages));
    } else if (currentPage > 3 && currentPage < totalPages - 2) {
      pages.push(btn(1));
      pages.push(dots("d1"));
      for (let i = currentPage - 1; i <= currentPage + 1; i++)
        pages.push(btn(i));
      pages.push(dots("d2"));
      pages.push(btn(totalPages));
    } else {
      pages.push(btn(1));
      pages.push(dots("d1"));
      for (let i = totalPages - 2; i <= totalPages; i++) pages.push(btn(i));
    }
    return pages;
  };
 
  return (
    <div>
      {/* Search + Record Count */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder="Filter Selected Tips..."
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            />
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |{" "}
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
 
      {/* Action Bar — Column Selection only */}
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible((v) => !v)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
 
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {headers.map((column, index) => {
                  const isTipId = index === 0;
                  return (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleColumnSelection(column);
                      }}
                      style={{
                        cursor: isTipId ? "not-allowed" : "pointer",
                        opacity: isTipId ? 0.7 : 1,
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`sel-tip-col-${index}`}
                        name="columnSelection"
                        value={column}
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        disabled={isTipId}
                        readOnly
                      />
                      <label
                        htmlFor={`sel-tip-col-${index}`}
                        style={{ cursor: isTipId ? "not-allowed" : "pointer" }}
                      >
                        {column}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
 
      {/* Table */}
      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections-selected-ques-list">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <td
                    className="Heading-tc"
                    style={{ textAlign: "left", paddingLeft: "8px" }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        color: "rgb(47, 46, 64)",
                        fontSize: "14px",
                        marginLeft: "84px",
                      }}
                    >
                      Schedule Date
                    </span>
                  </td>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      className="Heading-tc"
                      style={{
                        width: "1%",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "left",
                        }}
                      >
                        {heading}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
 
              <tbody>
                {paginatedData.map((row, rowIndex) => {
                  const tipId = row[0];
                  return (
                    <tr
                      key={rowIndex}
                      className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                    >
                      <td
                        style={{
                          width: "0.8%",
                          whiteSpace: "nowrap",
                          textAlign: "left",
                          verticalAlign: "middle",
                          padding: "8px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "18px",
                          }}
                        >
                          <img
                            src={DeleteIcon}
                            alt="remove tip"
                            style={{
                              width: "20px",
                              cursor: "pointer",
                              flexShrink: 0,
                            }}
                            onClick={() => handleRemoveRow(row)}
                          />
                          <img
                            src={ReplaceIcon}
                            alt="replace tip"
                            style={{
                              width: "24px",
                              cursor: "pointer",
                              flexShrink: 0,
                            }}
                            onClick={() => handleReplaceRow(row)}
                          />
                          <DateDropdown
                            value={scheduledDates[tipId] || ""}
                            onChange={(date) =>
                              setScheduledDates((prev) => ({
                                ...prev,
                                [tipId]: date,
                              }))
                            }
                            dateOptions={dateOptions}
                          />
                        </div>
                      </td>
 
                      {visibleColumns.map((column, cellIndex) => (
                        <td
                          key={cellIndex}
                          style={{
                            width: "100px",
                            textAlign: "left",
                            color: "#6A6A6A",
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                          }}
                        >
                          {cellIndex === 0 ? (
                            <span
                              className="truncated-text"
                              title={row[headers.indexOf(column)]}
                            >
                              {row[headers.indexOf(column)] ?? ""}
                            </span>
                          ) : (
                            <span
                              className="truncated-text-2"
                              title={row[headers.indexOf(column)]}
                            >
                              {row[headers.indexOf(column)] ?? ""}
                            </span>
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
 
          {/* Pagination */}
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="" />
            </button>
          </div>
        </>
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "#6A6A6A",
            fontSize: "16px",
          }}
        >
          No tips selected.
        </div>
      )}
    </div>
  );
};
 
// ─── Outer Wrapper ────────────────────────────────────────────────────────────
const SelectedTipOfDayTable = ({
  selectedTips = [],
  tipHeaders = [],
  setSelectedTips,
  allTipsList = [],
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  startDate = "",
  endDate = "",
  scheduledDates,
  setScheduledDates,
  selectedFrequency = null,
  currentDateTime = null,
}) => {

  // const getMinAllowedDate = () => {
  //   const now = new Date();
  //   const cutoffHour = 6; // 6 AM

  //   if (now.getHours() >= cutoffHour) {
  //     // After 6 AM → tomorrow
  //     const tomorrow = new Date(now);
  //     tomorrow.setDate(tomorrow.getDate() + 1);
  //     tomorrow.setHours(0, 0, 0, 0);
  //     return tomorrow;
  //   } else {
  //     // Before 6 AM → today is still allowed
  //     const today = new Date(now);
  //     today.setHours(0, 0, 0, 0);
  //     return today;
  //   }
  // };

  const getMinAllowedDate = () => {
    if (!currentDateTime) {
      // Fallback to local time if API data not available
      const now = new Date();
      const cutoffHour = 6;
      
      if (now.getHours() >= cutoffHour) {
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        return tomorrow;
      } else {
        const today = new Date(now);
        today.setHours(0, 0, 0, 0);
        return today;
      }
    }

    // Use API datetime
    const [hours, minutes, seconds] = currentDateTime.time.split(':').map(Number);
    const cutoffHour = 6;
    
    const apiDate = new Date(currentDateTime.date);
    
    if (hours >= cutoffHour) {
      // After 6 AM → tomorrow
      const tomorrow = new Date(apiDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      return tomorrow;
    } else {
      // Before 6 AM → today is allowed
      apiDate.setHours(0, 0, 0, 0);
      return apiDate;
    }
  };
  
  const frequencyGapDays = {
    once_in_1_day: 1,
    once_in_2_days: 2,
    once_in_3_days: 3,
    once_in_4_days: 4,
    once_in_5_days: 5,
    once_in_6_days: 6,
    once_in_week: 7,
  };
  // DropDown component passes the id string directly (not an object)
  const gapDays = frequencyGapDays[selectedFrequency?.id ?? selectedFrequency] ?? 1;
 
  // const dateOptions = useMemo(
  //   () => generateDateOptionsFromRange(startDate, endDate),
  //   [startDate, endDate]
  // );
 
  const dateOptions = useMemo(() => {
    const minAllowedDate = getMinAllowedDate();
    return generateDateOptionsFromRange(startDate, endDate, minAllowedDate);
  }, [startDate, endDate]);

  // Stable key from tip IDs — avoids re-running on every parent render
  const tipIdsKey = selectedTips.map((r) => r[0]).join(",");
 
  useEffect(() => {
    if (dateOptions.length === 0 || selectedTips.length === 0) return;
 
    // Always reassign all dates from scratch based on current order,
    // frequency gap, and date range. This handles:
    // - New tip added
    // - Frequency changed
    // - Date range changed
    setScheduledDates(() => {
      const next = {};
      let lastUsedIndex = -1;
 
      selectedTips.forEach((row) => {
        const id = String(row[0]);
        const nextIndex = lastUsedIndex < 0 ? 0 : lastUsedIndex + gapDays;
        if (nextIndex < dateOptions.length) {
          next[id] = dateOptions[nextIndex].value;
          lastUsedIndex = nextIndex;
        }
        // beyond date range → no date assigned
      });
 
      return next;
    });
  }, [tipIdsKey, dateOptions, gapDays]);
 
  const handleRemoveRow = (rowToDelete) => {
    const tipId = rowToDelete[0];
    setSelectedTips((prev) => prev.filter((r) => r[0] !== tipId));
  };
 
  const handleReplaceRow = (rowToReplace) => {
    const tipId = rowToReplace[0];
    const selectedIds = new Set(selectedTips.map((r) => r[0]));
    const candidate = allTipsList.find(
      (r) => r[0] !== tipId && !selectedIds.has(r[0])
    );
 
    if (!candidate) {
      setIsMessageBoxVisible?.(true);
      setActiveImg?.(ErrorImg);
      setMessageBox?.(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>No available tips in the list to replace the selected tip.</span>
          </div>
        </div>
      );
      return;
    }
 
    setSelectedTips((prev) =>
      prev.map((r) => (r[0] === tipId ? candidate : r))
    );
 
    // Keep the same date for the replaced tip
    setScheduledDates((prev) => {
      const next = { ...prev };
      const oldDate = next[tipId];
      delete next[tipId];
      if (oldDate) next[candidate[0]] = oldDate;
      return next;
    });
  };
 
  return (
    <div style={{ height: "auto", width: "100%" }}>
      <div style={{ position: "sticky", top: "0" }}>
        <SelectedTipsTableComponent
          headers={tipHeaders}
          data={selectedTips}
          handleRemoveRow={handleRemoveRow}
          handleReplaceRow={handleReplaceRow}
          scheduledDates={scheduledDates}
          setScheduledDates={setScheduledDates}
          dateOptions={dateOptions}
        />
      </div>
    </div>
  );
};
 
export default SelectedTipOfDayTable;
















// import React, { useState, useEffect, useRef, useMemo } from "react";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import DeleteIcon from "../../../Assets/Images/CommanImages/table_cross_icon.png";
// import ReplaceIcon from "../../../Assets/Images/CommanImages/tabler_replace-filled.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
 
//   // ─── Date Dropdown ────────────────────────────────────────────────────────────
//   const generateDateOptionsFromRange = (startDate, endDate) => {
//     const options = [];
//     if (!startDate || !endDate) return options;
    
//     const start = new Date(startDate);
//     const end = new Date(endDate);
    
//     // Generate all dates from start to end
//     for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
//       const label = d.toLocaleDateString("en-US", {
//         month: "short",
//         day: "2-digit",
//         year: "numeric",
//       });
//       const value = d.toISOString().split("T")[0];
//       options.push({ label, value });
//     }
    
//     return options;
//   };

//   const DateDropdown = ({ value, onChange, dateOptions }) => {
//     return (
//       <select
//         value={value || ""}
//         onChange={(e) => onChange(e.target.value)}
//         style={{
//           padding: "4px 6px",
//           borderRadius: "4px",
//           border: "1px solid #ccc",
//           cursor: "pointer",
//           fontSize: "13px",
//           color: "#2F2E40",
//           background: "#fff",
//           minWidth: "120px",
//         }}
//       >
//         <option value="">Select date</option>
//         {dateOptions.map((opt) => (
//           <option key={opt.value} value={opt.value}>
//             {opt.label}
//           </option>
//         ))}
//       </select>
//     );
//   };

// // ─── Inner Table Component ────────────────────────────────────────────────────
// const SelectedTipsTableComponent = ({
//   headers,
//   data,
//   handleRemoveRow,
//   handleReplaceRow,
//   scheduledDates,
//   setScheduledDates,
//   dateOptions,
// }) => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const columnDropdownRef = useRef(null);
 
//   // Mirror: first 5 columns visible by default
//   useEffect(() => {
//     if (headers.length > 0 && visibleColumns.length === 0) {
//       setVisibleColumns(headers.slice(0, 5));
//     }
//   }, [headers]);
 
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);
 
//   const handleColumnSelection = (column) => {
//     // Tip ID (index 0) always stays visible
//     if (column === headers[0]) return;
//     setVisibleColumns((prev) =>
//       prev.includes(column)
//         ? prev.filter((c) => c !== column)
//         : [...prev, column]
//     );
//   };
 
//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };
 
//   const handleSort = (column) => {
//     setSortConfig((prev) => ({
//       key: column,
//       direction:
//         prev.key === column && prev.direction === "asc" ? "desc" : "asc",
//     }));
//   };
 
//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };
 
//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };
 
//   const filteredData = useMemo(
//     () =>
//       data.filter((row) =>
//         searchQuery === ""
//           ? true
//           : row.some(
//               (cell) =>
//                 cell &&
//                 String(cell)
//                   .toLowerCase()
//                   .includes(searchQuery.toLowerCase())
//             )
//       ),
//     [data, searchQuery]
//   );
 
//   const sortedData = useMemo(() => {
//     if (sortConfig.key === null) return filteredData;
//     const colIndex = headers.indexOf(sortConfig.key);
//     return [...filteredData].sort((a, b) => {
//       if (a[colIndex] < b[colIndex])
//         return sortConfig.direction === "asc" ? -1 : 1;
//       if (a[colIndex] > b[colIndex])
//         return sortConfig.direction === "asc" ? 1 : -1;
//       return 0;
//     });
//   }, [filteredData, sortConfig, headers]);
 
//   const totalPages = Math.ceil(sortedData.length / pageSize);
 
//   const paginatedData = useMemo(() => {
//     const start = (currentPage - 1) * pageSize;
//     return sortedData.slice(start, start + pageSize);
//   }, [sortedData, currentPage, pageSize]);
 
//   const renderPagination = () => {
//     const pages = [];
//     const btn = (i) => (
//       <button
//         key={i}
//         onClick={() => handlePageChange(i)}
//         style={{ borderRadius: "5px" }}
//         className={i === currentPage ? "active" : ""}
//       >
//         {i}
//       </button>
//     );
//     const dots = (k) => (
//       <span key={k} style={{ borderRadius: "5px" }}>
//         ...
//       </span>
//     );
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) pages.push(btn(i));
//     } else if (currentPage <= 3) {
//       [1, 2, 3].forEach((i) => pages.push(btn(i)));
//       pages.push(dots("d1"));
//       pages.push(btn(totalPages));
//     } else if (currentPage > 3 && currentPage < totalPages - 2) {
//       pages.push(btn(1));
//       pages.push(dots("d1"));
//       for (let i = currentPage - 1; i <= currentPage + 1; i++)
//         pages.push(btn(i));
//       pages.push(dots("d2"));
//       pages.push(btn(totalPages));
//     } else {
//       pages.push(btn(1));
//       pages.push(dots("d1"));
//       for (let i = totalPages - 2; i <= totalPages; i++) pages.push(btn(i));
//     }
//     return pages;
//   };
 
//   return (
//     <div>
//       {/* Search + Record Count — identical to TableComponent */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder="Filter Selected Tips..."
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             />
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |{" "}
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color:
//                     size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
 
//       {/* Action Bar — Column Selection only */}
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible((v) => !v)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
 
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers.map((column, index) => {
//                   const isTipId = index === 0;
//                   return (
//                     <div
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleColumnSelection(column);
//                       }}
//                       style={{
//                         cursor: isTipId ? "not-allowed" : "pointer",
//                         opacity: isTipId ? 0.7 : 1,
//                       }}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`sel-tip-col-${index}`}
//                         name="columnSelection"
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         disabled={isTipId}
//                         readOnly
//                       />
//                       <label
//                         htmlFor={`sel-tip-col-${index}`}
//                         style={{ cursor: isTipId ? "not-allowed" : "pointer" }}
//                       >
//                         {column}
//                       </label>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
 
//       {/* Table */}
//       {data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections-selected-ques-list">
//             <table className="table-tc" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {/* Schedule Date Header */}
//                   <td
//                     className="Heading-tc"
//                     style={{
//                       textAlign: "left",
//                       paddingLeft: "8px",
//                     }}
//                   >
//                     <span
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "flex-start",
//                         color: "rgb(47, 46, 64)",
//                         fontSize: "14px",
//                         marginLeft: "84px",
//                       }}
//                     >
//                       Schedule Date
//                     </span>
//                   </td>
//                   {/* Other Headers */}
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       className="Heading-tc"
//                       style={{
//                         width: "1%",
//                         whiteSpace: "nowrap",
//                         textAlign: "left",
//                         padding: "8px 8px 8px 8px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                         }}
//                       >
//                         {heading}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>
 
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => {
//                   const tipId = row[0];
//                   return (
//                     <tr
//                       key={rowIndex}
//                       className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                     >
//                       {/* Schedule Date Cell */}
//                       <td
//                         style={{
//                           width: "0.8%",
//                           whiteSpace: "nowrap",
//                           textAlign: "left",
//                           verticalAlign: "middle",
//                           padding: "8px 8px 8px 8px",
//                         }}
//                       >
//                         <div
//                           style={{ display: "flex", alignItems: "center", gap: "18px" }}
//                         >
//                           {/* Delete */}
//                           <img
//                             src={DeleteIcon}
//                             alt="remove tip"
//                             style={{ width: "20px", cursor: "pointer", flexShrink: 0 }}
//                             onClick={() => handleRemoveRow(row)}
//                           />
//                           {/* Replace */}
//                           <img
//                             src={ReplaceIcon}
//                             alt="replace tip"
//                             style={{ width: "24px", cursor: "pointer", flexShrink: 0 }}
//                             onClick={() => handleReplaceRow(row)}
//                           />
//                           {/* Schedule Date Dropdown */}
//                           <DateDropdown
//                             value={scheduledDates[tipId] || ""}
//                             onChange={(date) =>
//                               setScheduledDates((prev) => ({
//                                 ...prev,
//                                 [tipId]: date,
//                               }))
//                             }
//                             dateOptions={dateOptions}
//                           />
//                         </div>
//                       </td>
                      
//                       {/* Other Cells */}
//                       {visibleColumns.map((column, cellIndex) => (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             width: "100px",
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: "200px",
//                           }}
//                         >
//                           {cellIndex === 0 ? (
//                             /* Tip ID with link styling */
//                             <span
//                               className="truncated-text"
//                               title={row[headers.indexOf(column)]}
//                             >
//                               {row[headers.indexOf(column)] ?? ""}
//                             </span>
//                           ) : (
//                             <span
//                               className="truncated-text-2"
//                               title={row[headers.indexOf(column)]}
//                             >
//                               {row[headers.indexOf(column)] ?? ""}
//                             </span>
//                           )}
//                         </td>
//                       ))}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
 
//           {/* Pagination — identical to TableComponent */}
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//         <div
//           style={{
//             textAlign: "center",
//             padding: "40px",
//             color: "#6A6A6A",
//             fontSize: "16px",
//           }}
//         >
//           No tips selected.
//         </div>
//       )}
//     </div>
//   );
// };
 
// // ─── Outer Wrapper ────────────────────────────────────────────────────────────
// const SelectedTipOfDayTable = ({
//   selectedTips = [],
//   tipHeaders = [],
//   setSelectedTips,
//   allTipsList = [],
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   startDate = "",
//   endDate = "",
//   scheduledDates,        
//   setScheduledDates,  
// }) => {
//   // const [scheduledDates, setScheduledDates] = useState({});
  
//   // Generate date options from the selected date range
//   const dateOptions = useMemo(
//     () => generateDateOptionsFromRange(startDate, endDate),
//     [startDate, endDate]
//   );

//   useEffect(() => {
//     if (dateOptions.length === 0 || selectedTips.length === 0) return;

//     setScheduledDates((prev) => {
//       const next = { ...prev };

//       // Clean up tips that were removed
//       Object.keys(next).forEach((id) => {
//         if (!selectedTips.find((r) => String(r[0]) === String(id))) {
//           delete next[id];
//         }
//       });

//       // Collect all already-used dates
//       const usedDates = new Set(Object.values(next).filter(Boolean));

//       // Assign dates to tips that don't have one yet
//       selectedTips.forEach((row) => {
//         const id = String(row[0]);
//         if (next[id]) return; // already has a date, skip

//         // Find the first available date not yet used
//         const available = dateOptions.find(opt => !usedDates.has(opt.value));
//         if (available) {
//           next[id] = available.value;
//           usedDates.add(available.value);
//         } else {
//           // All dates taken — fall back to first date option
//           next[id] = dateOptions[0].value;
//         }
//       });

//       return next;
//     });
//   }, [selectedTips, dateOptions]);

//   const handleRemoveRow = (rowToDelete) => {
//     const tipId = rowToDelete[0];
//     setSelectedTips((prev) => prev.filter((r) => r[0] !== tipId));
//   };
 
//   const handleReplaceRow = (rowToReplace) => {
//     const tipId = rowToReplace[0];
//     const selectedIds = new Set(selectedTips.map((r) => r[0]));
//     const candidate = allTipsList.find(
//       (r) => r[0] !== tipId && !selectedIds.has(r[0])
//     );
 
//     if (!candidate) {
//       setIsMessageBoxVisible?.(true);
//       setActiveImg?.(ErrorImg);
//       setMessageBox?.(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               No available tips in the list to replace the selected tip.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }
 
//     setSelectedTips((prev) =>
//       prev.map((r) => (r[0] === tipId ? candidate : r))
//     );
    
//     // Keep the same date for the replaced tip
//     setScheduledDates((prev) => {
//       const next = { ...prev };
//       const oldDate = next[tipId];
//       delete next[tipId];
//       if (oldDate) {
//         next[candidate[0]] = oldDate;
//       }
//       return next;
//     });
//   };
 
//   return (
//     <div style={{ height: "auto", width: "100%" }}>
//       <div style={{ position: "sticky", top: "0"}}>
//         <SelectedTipsTableComponent
//           headers={tipHeaders}
//           data={selectedTips}
//           handleRemoveRow={handleRemoveRow}
//           handleReplaceRow={handleReplaceRow}
//           scheduledDates={scheduledDates}
//           setScheduledDates={setScheduledDates}
//           dateOptions={dateOptions}
//         />
//       </div>
//     </div>
//   );
// };
 
// export default SelectedTipOfDayTable;












// const DateDropdown = ({ value, onChange, dateOptions }) => (
//   <select
//     value={value}
//     onChange={(e) => onChange(e.target.value)}
//     style={{
//       padding: "4px 6px",
//       borderRadius: "4px",
//       border: "1px solid #ccc",
//       cursor: "pointer",
//       fontSize: "13px",
//       color: "#2F2E40",
//       background: "#fff",
//       minWidth: "120px",
//     }}
//   >
//     {dateOptions.length === 0 ? (
//       <option value="">Select date range first</option>
//     ) : (
//       dateOptions.map((opt) => (
//         <option key={opt.value} value={opt.value}>
//           {opt.label}
//         </option>
//       ))
//     )}
//   </select>
// );
 
//   const DateDropdown = ({ value, onChange, dateOptions }) => {
//     // If no value is set but options exist, immediately sync state with first option
//     useEffect(() => {
//       if (!value && dateOptions.length > 0) {
//         onChange(dateOptions[0].value);
//       }
//     }, [value, dateOptions]);

//   return (
//     <select
//       value={value || (dateOptions[0]?.value ?? "")}
//       onChange={(e) => onChange(e.target.value)}
//       style={{
//         padding: "4px 6px",
//         borderRadius: "4px",
//         border: "1px solid #ccc",
//         cursor: "pointer",
//         fontSize: "13px",
//         color: "#2F2E40",
//         background: "#fff",
//         minWidth: "120px",
//       }}
//     >
//       {dateOptions.length === 0 ? (
//         <option value="">Select date range first</option>
//       ) : (
//         dateOptions.map((opt) => (
//           <option key={opt.value} value={opt.value}>
//             {opt.label}
//           </option>
//         ))
//       )}
//     </select>
//   );
// };







  // Auto-assign dates serially when tips are selected
  // useEffect(() => {
  //   if (dateOptions.length === 0) return;
    
  //   setScheduledDates((prev) => {
  //     const next = { ...prev };
  //     const existingTipIds = Object.keys(prev);
      
  //     // Track which dates are already assigned
  //     const usedDates = new Set(Object.values(prev));
  //     const availableDates = dateOptions
  //       .map(opt => opt.value)
  //       .filter(date => !usedDates.has(date));
      
  //     let dateIndex = 0;
      
  //     // Assign dates to new tips serially
  //     selectedTips.forEach((row) => {
  //       const id = row[0];
  //       if (!next[id]) {
  //         // Assign next available date
  //         if (dateIndex < availableDates.length) {
  //           next[id] = availableDates[dateIndex];
  //           dateIndex++;
  //         } else if (dateOptions.length > 0) {
  //           // If we run out of available dates, cycle through from beginning
  //           next[id] = dateOptions[dateIndex % dateOptions.length].value;
  //           dateIndex++;
  //         }
  //       }
  //     });
      
  //     // Clean up removed tips
  //     Object.keys(next).forEach((id) => {
  //       if (!selectedTips.find((r) => r[0] === id)) {
  //         delete next[id];
  //       }
  //     });
      
  //     return next;
  //   });
  // }, [selectedTips, dateOptions]);
 



// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
// import DeleteIcon from "./../../../Assets/Images/CommanImages/table_cross_icon.png";
// import ReplaceIcon from "./../../../Assets/Images/CommanImages/tabler_replace-filled.png";
// import EyeOpenIcon from "./../../../Assets/Images/CommanImages/eye_lock_open_icon.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
// import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { API_BASE_URL } from "../../../Config/Config";
// import EndPoints from "../../../Api/Endpoints";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";

// const TableComponent = ({
//   headers,
//   data,
//   searchPlaceholder,
//   renderQuestionText,
//   handleRemoveRow,
//   selectedSections,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   handleReplaceRow,
//   renderQuestionTextTable,
//   selectedSectionPerRow,
//   setSelectedSectionPerRow,
//   isReadOnlyMode,
// }) => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const columnDropdownRef = useRef(null);
//   const [filters, setFilters] = useState({});
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   // const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});

//   const generateSectionOptions = (selectedSections) => {
//     return Array.from({ length: selectedSections }, (_, i) => {
//       const label =
//         selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i); // ✅ numeric or alphabetic
//       return {
//         id: label,
//         label: label,
//       };
//     });
//   };

//   const options = generateSectionOptions(selectedSections || 1);
//   useEffect(() => {
//     if (data.length > 0 && selectedSections === 1) {
//       const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

//       const autoAssignDropdowns = {};
//       const autoAssignSectionWise = { [defaultSectionLabel]: [] };

//       data.forEach((row) => {
//         const questionId = row[1];
//         const questionText = row[2];

//         autoAssignDropdowns[questionId] = defaultSectionLabel;
//         autoAssignSectionWise[defaultSectionLabel].push({
//           id: questionId,
//           text: renderQuestionText(questionText),
//         });
//       });

//       setSelectedSectionPerRow(autoAssignDropdowns);
//       setSectionWiseQuestions?.(autoAssignSectionWise);
//     } else if (selectedSections > 1) {
//       setSelectedSectionPerRow({});
//       setSectionWiseQuestions({});
//     }
//   }, [data, selectedSections, selecteSectionTypeID]);


//   useEffect(() => {
//     if (headers.length > 0 && visibleColumns.length === 0) {
//       const questionIdColumn = headers[1]; // Question ID at index 1
//       const sectionColumn = headers[0]; // Section at index 0
      
//       const initialVisible = headers
//         .slice(0, 6) // Get first 6 columns
//         .filter((_, index) => 
//           index !== 4 && 
//           index !== 5 && 
//           index !== 0 // ✅ Exclude Section (index 0)
//         );
      
//       // Always include Section and Question ID
//       const finalVisible = [sectionColumn, ...initialVisible];
//       if (!finalVisible.includes(questionIdColumn)) {
//         finalVisible.push(questionIdColumn);
//       }
      
//       setVisibleColumns(finalVisible);
//     }
//   }, [headers, visibleColumns]);

//   const handleColumnSelection = (column) => {
//     const questionIdColumn = headers[1]; // Question ID at index 1
//     const sectionColumn = headers[0]; // Section at index 0
    
//     // Prevent toggling Section and Question ID
//     if (column === questionIdColumn || column === sectionColumn) {
//       return;
//     }
    
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((col) => col !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {" "}
//             {i}{" "}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             {totalPages}{" "}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };
//   const [columnWidth, setColumnWidth] = useState(400);
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);

//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (event) => {
//     if (isResizing.current) {
//       const newWidth = Math.max(
//         100,
//         event.clientX - columnRef.current.offsetLeft
//       );
//       setColumnWidth(newWidth);
//     }
//   };

//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                   {headers
//                     .filter((_, index) => 
//                       index !== 0 && // ✅ Skip Section (index 0) from dropdown
//                       index !== 4 && 
//                       index !== 5
//                     )
//                     .map((column, index) => {
//                       const originalIndex = headers.indexOf(column);
//                       const isQuestionId = originalIndex === 1; // Check if it's Question ID
                      
//                       return (
//                         <div
//                           key={index}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleColumnSelection(column);
//                           }}
//                           style={{
//                             cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             opacity: isQuestionId ? 0.7 : 1,
//                           }}
//                         >
//                           <input
//                             type="checkbox"
//                             id={`column-${index}`}
//                             name="columnSelection"
//                             value={column}
//                             className="square-checkbox-tc"
//                             checked={visibleColumns.includes(column)}
//                             disabled={isQuestionId} 
//                             readOnly
//                           />
//                           <label 
//                             htmlFor={`column-${index}`}
//                             style={{
//                               cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             }}
//                           >
//                             {column}
//                           </label>
//                         </div>
//                       );
//                     })}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections-selected-ques-list">
//             <table className="table-tc" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       key={index}
//                       ref={index === 1 ? columnRef : null}
//                       className={`Heading-tc resizable-header ${
//                         index === 1 ? "resizable-header" : ""
//                       }`}
//                       style={{
//                         textAlign: "right",
//                         cursor: "pointer",
//                         width: index === 1 ? `${columnWidth}px` : "auto",
//                         position: "relative",
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                           marginLeft: index === 0 ? "130px" : "",
//                         }}
//                       >
//                         {heading}
//                         {index === 2 && (
//                           <div
//                             className="resize-handle"
//                             onMouseDown={handleMouseDown}
//                           ></div>
//                         )}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {/* {paginatedData.map((row, rowIndex) => ( */}
//                 {paginatedData.map((row, rowIndex) => {
//                   const questionId = row[1]; // ✅ Index for Question ID
//                   const questionText = row[2]; // ✅ Index for Question Text
//                   return (
//                     <tr
//                       key={rowIndex}
//                       className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                     >
//                       {visibleColumns.map((column, cellIndex) => (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             width:
//                               cellIndex === 3 ? `${columnWidth}px` : "100px",
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: `${columnWidth}px`,
//                           }}
//                         >
//                           {cellIndex === 0 ? ( // Ensure link only appears once
//                             <div
//                               style={{ display: "flex", alignItems: "center" }}
//                             >
//                               <div
//                                 className="flag-container-ques-bank-dash"
//                                 style={{
//                                   width: "220px",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "20px",
//                                 }}
//                               >
//                                 <img
//                                   src={DeleteIcon}
//                                   alt="flag count"
//                                   style={{
//                                     width: "20px",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleRemoveRow && handleRemoveRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode && handleRemoveRow) {
//                                       handleRemoveRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <img
//                                   src={ReplaceIcon}
//                                   alt="replace question"
//                                   style={{
//                                     width: "24px",
//                                     cursor: "pointer",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleReplaceRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode) {
//                                       handleReplaceRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <div style={{ width: "24px" }}>
//                                   {row[4] === 13 && (
//                                     <img
//                                       src={EyeLockIcon}
//                                       alt="replace question"
//                                       style={{
//                                         width: "24px",
//                                         cursor: "pointer",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                                 <select
//                                   style={{
//                                     width: "70px",
//                                     padding: "5px",
//                                     borderRadius: "4px",
//                                     border: "1px solid #ccc",
//                                     cursor: "pointer",
//                                   }}
//                                   value={
//                                     selectedSectionPerRow[questionId] || ""
//                                   }
//                                   onChange={(e) => {
//                                     const sectionLabel = e.target.value;
//                                     setSelectedSectionPerRow((prev) => ({
//                                       ...prev,
//                                       [questionId]: sectionLabel,
//                                     }));

//                                     setSectionWiseQuestions?.((prev) => {
//                                       const updated = { ...prev };

//                                       // Remove this question from all sections
//                                       for (const sec in updated) {
//                                         updated[sec] = updated[sec].filter(
//                                           (q) => q.id !== questionId
//                                         );
//                                       }

//                                       // Add to new section
//                                       if (sectionLabel) {
//                                         if (!updated[sectionLabel])
//                                           updated[sectionLabel] = [];
//                                         updated[sectionLabel].push({
//                                           id: questionId,
//                                           text: questionText,
//                                         });
//                                       }
//                                       return updated;
//                                     });
//                                   }}
//                                   disabled={isReadOnlyMode}
//                                 >
//                                   <option value="">Select</option>
//                                   {options.map((option) => (
//                                     <option key={option.id} value={option.id}>
//                                       {option.label}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>
//                               <Link style={{ color: "#337ab7" }}>
//                                 <span
//                                   className="truncated-text"
//                                   title={row[headers.indexOf(column)]}
//                                 >
//                                   {" "}
//                                   {headers.indexOf(column) === 2
//                                     ? renderQuestionTextTable(
//                                         row[headers.indexOf(column)]
//                                       )
//                                     : row[headers.indexOf(column)]}{" "}
//                                 </span>
//                               </Link>
//                             </div>
//                           ) : (
//                             <span className="truncated-text-2">
//                               {" "}
//                               {headers.indexOf(column) === 2
//                                 ? renderQuestionTextTable(
//                                     row[headers.indexOf(column)]
//                                   )
//                                 : row[headers.indexOf(column)]}{" "}
//                             </span>
//                           )}
//                         </td>
//                       ))}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               {" "}
//               <img src={leftArrow} alt="" />{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {" "}
//               {"<"}
//             </button>{" "}
//             {renderPagination()}{" "}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {" "}
//               {">"}{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               {" "}
//               <img src={rightArrow} alt="" />{" "}
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               {" "}
//               <p>X</p>{" "}
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               {isFiltersApplied && (
//                 <button
//                   className="reset-btn-question-review-dash"
//                   onClick={handleResetFilter}
//                 >
//                   {" "}
//                   RESET{" "}
//                 </button>
//               )}
//               <button
//                 className="apply-btn-question-review-dash"
//                 onClick={handleApplyFilter}
//               >
//                 {" "}
//                 APPLY{" "}
//               </button>
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
//                 .map((header, filteredIndex) => {
//                   const originalIndex =
//                     filteredIndex === 0
//                       ? 0
//                       : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0);
//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 0 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }
//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const TableDetailsSelectedQuestions = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
//   selectedSections,
//   setQuestionIds,
//   activeSubjectId,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   allQuesList,
//   draftData,
//   isReadOnlyMode,
//   setDifficultyCount,
//   version,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
//   const [draftLoaded, setDraftLoaded] = useState(false);

//   const renderQuestionTextTable = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   useEffect(() => {
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );

//     const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//     if (reportDashboardData.length && draftLoaded) {
//       reportDashboardData.forEach((row) => {
//         const diff = row[difficultyIndex]?.toLowerCase();
//         if (["easy", "medium", "tough"].includes(diff)) {
//           difficultyCount[diff]++;
//         }
//       });
//     }
//     setDifficultyCount?.(difficultyCount);
//   }, [reportDashboardData, headers, draftLoaded, activeSubjectId]);

//   const quesTypeMapping = {
//     "Single Correct MCQ": 1,
//     "Multi Correct MCQ": 2,
//     "Fill in the blanks": 3,
//     "True/False": 4,
//   };
//   const fetchSelectedQuestions = async () => {
//     const subjectWiseSelected = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const deletedRowMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );

//     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//     const draftSubjectQuestionsRaw =
//       draftData?.subjects?.find(
//         (subject) => subject.subject_superset_id === activeSubjectId
//       )?.questions || [];
//     const draftSubjectQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 1
//     );
//     const draftSubjectDeletedQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 2
//     );

//     const draftSubjectIds = draftSubjectQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );
//     const deletedDraftIds = draftSubjectDeletedQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );
//     const mergedIds = Array.from(
//       new Set([...localSubjectIds, ...draftSubjectIds])
//     );

//     // ✅ Remove deleted IDs
//     const deletedIds = deletedRowMap[activeSubjectId] || [];
//     const finalIds = mergedIds.filter((id) => !deletedIds.includes(id));

//     if (finalIds.length === 0) {
//       setReportDashboardData([]);
//       setHeaders([]);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${EndPoints.PRISM_GET_QUESTIONS_BY_IDS}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("other")}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(finalIds),
//         }
//       );

//       const result = await response.json();
//       const tableData = result?.data?.table_data || [];

//       if (tableData.length > 1) {
//         const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
//         const rows = tableData.slice(1);
//         setHeaders(["Section", ...headers]);
//         // setReportDashboardData(rows.map((row) => ["", ...row]));

//         // Ensure table rows follow the order of `finalIds`
//         const idToRowMap = new Map();
//         rows.forEach((row) => {
//           const quesId = row[0]; // assuming 0 is Question ID (since headers have ["Section", ...])
//           idToRowMap.set(quesId, row);
//         });

//         const orderedRows = finalIds
//           .map((id) => idToRowMap.get(id))
//           .filter((row) => row); // skip if not found
//         setReportDashboardData(orderedRows.map((row) => ["", ...row])); // add empty section as first column

//         // ✅ Auto-assign default section (A/1) when selecting questions for the first time if only one section exists
//         if (selectedSections === 1) {
//           const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";
//           const newSectionMap = {};

//           orderedRows.forEach((row) => {
//             const questionId = row[0]; // before "Section" column
//             newSectionMap[questionId] = defaultSection;
//           });

//           setSelectedSectionPerRow(newSectionMap);

//           // Also build sectionWiseQuestions
//           const sectionQuesMap = {
//             [defaultSection]: orderedRows.map((row) => ({
//               id: row[0],
//               text: renderQuestionTextTable(row[2]),
//             })),
//           };
//           setSectionWiseQuestions(sectionQuesMap);
//         }

//         const quesTypeMapPerSubject = {}; // New variable
//         const questionTypeIndex = headers.findIndex((h) =>
//           h.toLowerCase().includes("question type")
//         );
//         if (questionTypeIndex !== -1) {
//           rows.forEach((row) => {
//             const quesId = row[0]; // First column is Question ID (after Section)
//             const quesTypeText = row[questionTypeIndex];
//             const quesTypeId = quesTypeMapping[quesTypeText] || null;

//             if (quesTypeId !== null) {
//               quesTypeMapPerSubject[quesId] = quesTypeId;
//             }
//           });

//           // ✅ Save as a new key in localStorage
//           const existingTypeMap = JSON.parse(
//             localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//           );
//           localStorage.setItem(
//             "subjectWiseQuesTypeIds",
//             JSON.stringify({
//               ...existingTypeMap,
//               [activeSubjectId]: quesTypeMapPerSubject,
//             })
//           );
//         }

//         // ✅ Update localStorage: merge both
//         const existing = JSON.parse(
//           localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//         );
//         localStorage.setItem(
//           "subjectWiseSelectedRowIds",
//           JSON.stringify({
//             ...existing,
//             [activeSubjectId]: finalIds,
//           })
//         );
//         const existingDeleted = JSON.parse(
//           localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//         );
//         const currentSelected =
//           JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
//             activeSubjectId
//           ] || [];

//         const mergedDeletedIds = deletedDraftIds.filter(
//           (id) => !currentSelected.includes(id)
//         ); // ✅ do not save as deleted if user already reselected

//         localStorage.setItem(
//           "subjectWiseDeletedRowIds",
//           JSON.stringify({
//             ...existingDeleted,
//             [activeSubjectId]: mergedDeletedIds,
//           })
//         );
//         setDraftLoaded(true);
//       }
//     } catch (error) {
//       console.error("Failed to fetch selected questions:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSelectedQuestions();
//   }, [activeSubjectId, draftData, version]);

//   // Save selectedSectionPerRow to localStorage every time it updates
//   useEffect(() => {
//     if (
//       !selectedSectionPerRow ||
//       Object.keys(selectedSectionPerRow).length === 0
//     )
//       return;

//     const existingMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...existingMap,
//         [activeSubjectId]: selectedSectionPerRow,
//       })
//     );
//   }, [selectedSectionPerRow, activeSubjectId]);

//   // Restore selectedSectionPerRow and sectionWiseQuestions from localStorage
//   useEffect(() => {
//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const subjectMap = savedMap[activeSubjectId] || {};

//     setSelectedSectionPerRow(subjectMap); // 🟢 restore dropdowns

//     const newSectionWise = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = subjectMap[quesId];
//       if (section) {
//         if (!newSectionWise[section]) newSectionWise[section] = [];
//         newSectionWise[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(newSectionWise); // 🟢 restore section mapping
//   }, [reportDashboardData, draftLoaded, activeSubjectId]);

//   useEffect(() => {
//     if (!reportDashboardData.length || !draftLoaded) return;

//     const subject = draftData?.subjects?.find(
//       (s) => s.subject_superset_id === activeSubjectId
//     );
//     const dropdownMap = {};

//     subject?.questions?.forEach((q) => {
//       if (q.status === 1 && q.section_name) {
//         const quesId = q.parse_ques_set_question_id;
//         dropdownMap[quesId] = q.section_name;
//       }
//     });

//     // 🧠 Merge draft (dropdownMap) + localStorage map
//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const savedSubjectMap = savedMap[activeSubjectId] || {};

//     const mergedMap = {
//       ...dropdownMap, // from draft
//       ...savedSubjectMap, // from previously saved manual changes
//     };

//     setSelectedSectionPerRow(mergedMap);

//     // 🧠 Auto-assign section if none exists and only one section add this logic on Monday 14/07/2025
//     const finalMap = { ...mergedMap };
//     const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";

//     if (selectedSections === 1) {
//       reportDashboardData.forEach((row) => {
//         const quesId = row[1];
//         if (!finalMap[quesId]) {
//           finalMap[quesId] = defaultSection;
//         }
//       });
//     }

//     setSelectedSectionPerRow(finalMap);

//     // 💾 Save merged version back
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...savedMap,
//         [activeSubjectId]: mergedMap,
//       })
//     );

//     // 🛠 Build sectionWiseQuestions from merged map
//     const sectionMap = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = mergedMap[quesId];
//       if (section) {
//         if (!sectionMap[section]) sectionMap[section] = [];
//         sectionMap[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(sectionMap);
//   }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

//   const handleRemoveRow = (rowToDelete) => {
//     const questionId = rowToDelete[1];
//     // Remove from UI
//     const updatedData = reportDashboardData.filter(
//       (row) => row[1] !== questionId
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Remove from subjectWiseSelectedRowIds
//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const updatedSelected = (selectedMap[activeSubjectId] || []).filter(
//       (id) => id !== questionId
//     );
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedSelected,
//       })
//     );

//     // ✅ Add to subjectWiseDeletedRowIds
//     const deletedMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );
//     const updatedDeleted = Array.from(
//       new Set([...(deletedMap[activeSubjectId] || []), questionId])
//     );
//     localStorage.setItem(
//       "subjectWiseDeletedRowIds",
//       JSON.stringify({
//         ...deletedMap,
//         [activeSubjectId]: updatedDeleted,
//       })
//     );

//     // ✅ Update difficulty count
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );
//     const diff = rowToDelete[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(diff)) {
//       setDifficultyCount((prev) => ({
//         ...prev,
//         [diff]: Math.max(0, (prev?.[diff] || 0) - 1),
//       }));
//     }
//   };

//   const handleReplaceRow = (rowToReplace) => {
//     const questionIdIndex = 1; // in reportDashboardData
//     const currentQuesId = rowToReplace[questionIdIndex];
//     const matchedRow = allQuesList.find((r) => r[0] === currentQuesId);
//     if (!matchedRow) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               This question is missing from the current question set and cannot
//               be replaced.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }
//     const groupIdIndexInAll =
//       headers.findIndex((h) => h.toLowerCase().includes("group id")) - 1; // -1 because allQuesList doesn't have "Section"
//     const currentGroupId = matchedRow[groupIdIndexInAll];

//     console.log("✅ Correct Group ID from allQuesList:", currentGroupId);

//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const selectedIds = selectedMap[activeSubjectId] || [];

//     // ✅ Get same-group rows (excluding current and already selected)
//     const sameGroupRows = allQuesList.filter(
//       (r) =>
//         r[groupIdIndexInAll] === currentGroupId &&
//         r[0] !== currentQuesId &&
//         !selectedIds.includes(r[0])
//     );

//     console.log(
//       "🔄 Replacement candidates:",
//       sameGroupRows.map((r) => r[0])
//     );

//     if (sameGroupRows.length === 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               No available questions in the list to replace the selected
//               question.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }
//     const replacementRow = sameGroupRows[0];
//     const updatedData = reportDashboardData.map((row) =>
//       row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Update localStorage IDs
//     const updatedIds = selectedIds
//       .filter((id) => id !== currentQuesId)
//       .concat(replacementRow[0]);
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedIds,
//       })
//     );
//     const quesTypeText =
//       replacementRow[
//         headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1
//       ]; // -1 because we added "Section"
//     const quesTypeId = quesTypeMapping[quesTypeText] || null;

//     if (quesTypeId !== null) {
//       const existingQuesTypeMap = JSON.parse(
//         localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//       );
//       const updatedQuesTypeMap = {
//         ...(existingQuesTypeMap[activeSubjectId] || {}),
//         [replacementRow[0]]: quesTypeId,
//       };
//       delete updatedQuesTypeMap[currentQuesId];

//       localStorage.setItem(
//         "subjectWiseQuesTypeIds",
//         JSON.stringify({
//           ...existingQuesTypeMap,
//           [activeSubjectId]: updatedQuesTypeMap,
//         })
//       );
//     }
//     console.log("✅ Replacement successful:", replacementRow[0]);
//   };

//   return (
//     <div style={{ height: "auto", width: "100%" }}>
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         <TableComponent
//           headers={headers}
//           data={reportDashboardData}
//           searchPlaceholder="Filter Questions..."
//           dataClient={dataClient}
//           setPagePath={setPagePath}
//           renderQuestionText={renderQuestionText}
//           handleRemoveRow={handleRemoveRow}
//           selectedSections={selectedSections}
//           setIsMessageBoxVisible={setIsMessageBoxVisible}
//           setMessageBox={setMessageBox}
//           setActiveImg={setActiveImg}
//           setSectionWiseQuestions={setSectionWiseQuestions}
//           selecteSectionTypeID={selecteSectionTypeID}
//           setQuestionIds={setQuestionIds}
//           // tableQuestions={tableQuestions}
//           allQuesList={allQuesList}
//           handleReplaceRow={handleReplaceRow}
//           renderQuestionTextTable={renderQuestionTextTable}
//           selectedSectionPerRow={selectedSectionPerRow}
//           setSelectedSectionPerRow={setSelectedSectionPerRow}
//           isReadOnlyMode={isReadOnlyMode}
//         />
//       </div>
//     </div>
//   );
// };

// export default TableDetailsSelectedQuestions;